import React from "react"
import MarkdownToJsx from "markdown-to-jsx"
import { defaultMarkdownElements } from "./elements"

type MarkdownToJsxProps = React.ComponentProps<typeof MarkdownToJsx>
type MarkdownToJsxOptions = NonNullable<MarkdownToJsxProps["options"]>
export interface MarkdownProps {
  wrapper?: MarkdownToJsxOptions["wrapper"]
  overrides?: Partial<unknown>
  options?: Omit<MarkdownToJsxOptions, "overrides" | "wrapper">
  /** Render without a wrapping block element — for use inside a label/checkbox. */
  inline?: boolean
  children: MarkdownToJsxProps["children"]
}

export function Markdown({
  overrides = {},
  options = {},
  children,
  inline = false,
  wrapper = ({ children }: React.PropsWithChildren) => children
}: MarkdownProps) {
  if (!children) {
    return null
  }
  return (
    <MarkdownToJsx
      options={{
        ...options,
        wrapper,
        overrides: {
          ...defaultMarkdownElements,
          ...overrides
        },
        forceBlock: !inline,
        forceInline: inline
      }}
    >
      {children}
    </MarkdownToJsx>
  )
}
